import { render, staticRenderFns } from "./Room.html?vue&type=template&id=235cf9f8&external"
import script from "./Room.js?vue&type=script&lang=js&external"
export * from "./Room.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports